export * from "./exporter/CSVExporter.js"
export * from "./exporter/DXFExporter.js"
export * from "./exporter/GeoJSONExporter.js"
export * from "./exporter/LASExporter.js"

export * from "./Actions.js";
export * from "./AnimationPath.js";
export * from "./Annotation.js";
export * from "./defines.js";
export * from "./Enum.js";
export * from "./EventDispatcher.js";
export * from "./Features.js";
export * from "./KeyCodes.js";
export * from "./LRU.js";
export * from "./PointCloudEptGeometry.js";
export * from "./PointCloudOctree.js";
export * from "./PointCloudOctreeGeometry.js";
export * from "./PointCloudTree.js";
export * from "./Points.js";
export * from "./exporter/LASExporter.js";
export * from "./Potree_update_visibility.js";
export * from "./PotreeRenderer.js";
export * from "./ProfileRequest.js";
export * from "./TextSprite.js";
export * from "./utils.js";
export * from "./Version.js";
export * from "./WorkerPool.js";
export * from "./XHRFactory.js";
export * from "./viewer/SaveProject.js";
export * from "./viewer/LoadProject.js";
export * from "./viewer/profile.js";

export * from "./materials/ClassificationScheme.js";
export * from "./materials/EyeDomeLightingMaterial.js";
export * from "./materials/Gradients.js";
export * from "./materials/NormalizationEDLMaterial.js";
export * from "./materials/NormalizationMaterial.js";
export * from "./materials/PointCloudMaterial.js";

export * from "./loader/POCLoader.js";
export * from "./modules/loader/2.0/OctreeLoader.js";
export * from "./loader/EptLoader.js";
export * from "./loader/ept/BinaryLoader.js";
export * from "./loader/ept/LaszipLoader.js";
export * from "./loader/ept/ZstandardLoader.js";
export * from "./loader/PointAttributes.js";
export * from "./loader/ShapefileLoader.js";
export * from "./loader/GeoPackageLoader.js";

export * from "./utils/Box3Helper.js";
export * from "./utils/ClippingTool.js";
export * from "./utils/ClipVolume.js";
export * from "./utils/GeoTIFF.js";
export * from "./utils/Measure.js";
export * from "./utils/MeasuringTool.js";
export * from "./utils/Message.js";
export * from "./utils/PointCloudSM.js";
export * from "./utils/PolygonClipVolume.js";
export * from "./utils/Profile.js";
export * from "./utils/ProfileTool.js";
export * from "./utils/ScreenBoxSelectTool.js";
export * from "./utils/SpotLightHelper.js";
export * from "./utils/TransformationTool.js";
export * from "./utils/Volume.js";
export * from "./utils/VolumeTool.js";
export * from "./utils/Compass.js";

export * from "./viewer/viewer.js";
export * from "./viewer/Scene.js";
export * from "./viewer/HierarchicalSlider.js";

export * from "./modules/OrientedImages/OrientedImages.js";
export * from "./modules/Images360/Images360.js";
export * from "./modules/CameraAnimation/CameraAnimation.js";
export * from "./modules/CutFillVolume/CutFillVolume.js";
export {computeCutFillVolume} from "./modules/CutFillVolume/CutFillJob.js";
export {buildGraveReportPdf} from "./modules/CutFillVolume/GraveReportPdfBuilder.js";
export {captureViewpoint, applyViewpoint, flyToPoint, captureViewerImage} from "./modules/POI/viewpoint.js";
export {buildPoiReportPdf} from "./modules/POI/PoiReportPdfBuilder.js";
export * from "./modules/BaseMap/BaseMap3D.js";
export * from "./modules/ProfileOverlays/ProfileOverlays.js";
export * from "./modules/ProfileOverlays/ProfileTools.js";
export * from "./modules/LER/LER.js";
export * from "./modules/LER/LERParser.js";
export * from "./modules/LER/LERWFS.js";
export * from "./modules/LER/OgcApiFeatures.js";
export * from "./modules/LER/GenericVectorParser.js";
export * from "./modules/DANVA/DANVAParser.js";
export * from "./modules/DANVA/DANVAExporter.js";
export * from "./modules/Digitizing/Digitizing.js";
export * from "./modules/Digitizing/FXLParser.js";
export * from "./modules/IFC/IFCModule.js";
export * from "./modules/DeviationAnalysis/DeviationAnalysis.js";
export * from "./modules/SectionPlanes/SectionPlanes.js";
export * from "./modules/Snitplan/snitplanGeometry.js";
export * from "./modules/Snitplan/SnitVolume.js";
export * from "./modules/Snitplan/SnitplanManager.js";
export * from "./modules/SectionPlanes/SectionIntersection.js";
export * from "./modules/PointCloudQuery/PointCloudQuery.js";
export * from "./modules/PointCloudQuery/FullPointExport.js";
export * from "./modules/ShortestDistance/TriangleBVH.js";
export * from "./modules/ShortestDistance/ShortestDistance.js";
export * from "./modules/ThreeAxisLaser/ThreeAxisLaser.js";
export * from "./modules/Snapping/MeshSnapping.js";
export * from "./modules/PrecisionMeasure/PrecisionMeasure.js";
export * from "./modules/Permissions/Permissions.js";

export * from "./modules/loader/2.0/OctreeLoader.js";

export {OrbitControls} from "./navigation/OrbitControls.js";
export {FirstPersonControls} from "./navigation/FirstPersonControls.js";
export {EarthControls} from "./navigation/EarthControls.js";
export {DeviceOrientationControls} from "./navigation/DeviceOrientationControls.js";
export {VRControls} from "./navigation/VRControls.js";
// Label-motoren og skærmkonstant skalering, så Vue-laget "GCP'er" (Lag) bruger de samme labels som
// Digitalisering (createStyledLabel(text, "gcp") = rød kant) frem for en særskilt label-implementation.
export {createStyledLabel} from "./digitization/DigitizationStyle.js";
export {formatCoordinateLine} from "./digitization/FeatureVisual.js";
export {computeScreenSpaceScale, ScreenSpaceSizes} from "./digitization/ScreenSpaceScale.js";
// Sprog til Digitalisering (værktøjer, dialoger, hjælp, rapporter): værten sætter det aktive sprog, fx Potree.setDigitizationLanguage("en")
export {setLanguage as setDigitizationLanguage, getLanguage as getDigitizationLanguage, onLanguageChange as onDigitizationLanguageChange, t as translate, numberLocale} from "./digitization/i18n/index.js";

import "./extensions/OrthographicCamera.js";
import "./extensions/PerspectiveCamera.js";
import "./extensions/Ray.js";

import {LRU} from "./LRU.js";
import {POCLoader} from "./loader/POCLoader.js";
import {CopcLoader, EptLoader} from "./loader/EptLoader.js";
import {PointCloudOctree} from "./PointCloudOctree.js";
import {WorkerPool} from "./WorkerPool.js";
import {installTitleTooltips} from "./viewer/TitleTooltip.js";

export const workerPool = new WorkerPool();

export const version = {
	major: 1,
	minor: 8,
	suffix: '.0'
};

export let lru = new LRU();

// Deploy-verifikationsmarkør (INTEGRATION-MAP.md) - bump datoen her ved enhver ny build, så det kan ses med det samme, hvilken kildekode-
// tilstand der reelt er indlæst, uden at skulle grep'e den byggede fil manuelt. Ikke en del af Potrees egen version ovenfor.
// Potree logger ikke selv længere: værten (geonote-pointcloud-frontend, plugins/dev-header.client.js) læser `version` og `buildInfo` og
// skriver ÉN samlet header i konsollen. commit sættes af rollup.config.js ved bygning (git kort hash, "+" = ucommittede ændringer).
export const buildInfo = {
	marker: '2026-11-04-dxf-r12',
	commit: '__POTREE_BUILD_COMMIT__',
	// hash af de ændrede/nye kildefiler, bundlen er bygget af (build-manifest.json ligger ved siden af bundlen)
	source: '__POTREE_BUILD_SOURCE__'
};
// Native title-tooltips (plain DOM) erstattes af PointViews egen tooltip - se viewer/TitleTooltip.js.
installTitleTooltips();

export let pointBudget = 1 * 1000 * 1000;
export let framenumber = 0;
export let numNodesLoading = 0;
// Antal samtidige node-indlæsninger tilladt under normal kamera-navigation
// (håndhæves i OctreeGeometry.js, PointCloudOctreeGeometry.js,
// PointCloudEptGeometry.js, PointCloudArena4DGeometry.js og
// Potree_update_visibility.js - én fælles tæller, én fælles grænse).
// Var tidligere en fast værdi (4), helt uafhængig af maskinens reelle
// CPU-kapacitet (AUDIT-PERFORMANCE-2026-09-19.md #7): på en hurtig
// forbindelse med ledige CPU-kerner kunne alligevel kun 4 noder nogensinde
// dekodes parallelt. WorkerPool.js opretter decode-workere helt uden eget
// loft (kun styret af denne tæller), så værdien her er reelt den eneste
// bremse på decode-parallelitet - navigator.hardwareConcurrency er derfor
// et mere retvisende udgangspunkt end en fast konstant.
// Gulv på 4 bevarer den hidtidige minimums-adfærd på svage/ukendte
// maskiner (fx hvis hardwareConcurrency ikke understøttes). Loft på 16
// undgår ukontrolleret worker-opsprøjt på maskiner med meget højt
// kernetal - RoiPointLoader.js's egen midlertidige hævning til 64
// (se dens kommentar ved linje ~389) er bevidst kun til dens eget
// afgrænsede, kortvarige bulk-scenarie og gælder uændret ovenpå denne nye
// baseline, da den altid gemmer/gendanner den AKTUELLE værdi af denne
// variabel, uanset hvad den måtte være.
export let maxNodesLoading = Math.min(16, Math.max(4, (typeof navigator !== "undefined" && navigator.hardwareConcurrency) || 4));

export const debug = {};

let scriptPath = "";

if (document.currentScript && document.currentScript.src) {
	scriptPath = new URL(document.currentScript.src + '/..').href;
	if (scriptPath.slice(-1) === '/') {
		scriptPath = scriptPath.slice(0, -1);
	}
} else if(import.meta){
	scriptPath = new URL(import.meta.url + "/..").href;
	if (scriptPath.slice(-1) === '/') {
		scriptPath = scriptPath.slice(0, -1);
	}
}else {
	console.error('Potree was unable to find its script path using document.currentScript. Is Potree included with a script tag? Does your browser support this function?');
}

let resourcePath = scriptPath + '/resources';

// scriptPath: build/potree
// resourcePath:build/potree/resources
// fras edit
export {scriptPath, resourcePath};


export function loadPointCloud(path, name, callback){
	let loaded = function(e){
		e.pointcloud.name = name;
		callback(e);
	};

	let promise = new Promise( resolve => {

		// load pointcloud
		if (!path){
			// TODO: callback? comment? Hello? Bueller? Anyone?
		} else if (path.includes('.copc.laz')) {
			CopcLoader.load(path, function(geometry) {
				if (!geometry) {
					console.error(new Error(`failed to load point cloud from URL: ${path}`));
				}
				else {
					let pointcloud = new PointCloudOctree(geometry);
					resolve({type: 'pointcloud_loaded', pointcloud: pointcloud});
				}
			});
		} else if (path.indexOf('ept.json') > 0) {
			EptLoader.load(path, function(geometry) {
				if (!geometry) {
					console.error(new Error(`failed to load point cloud from URL: ${path}`));
				}
				else {
					let pointcloud = new PointCloudOctree(geometry);
					//loaded(pointcloud);
					resolve({type: 'pointcloud_loaded', pointcloud: pointcloud});
				}
			});
		} else if (path.indexOf('cloud.js') > 0) {
			POCLoader.load(path, function (geometry) {
				if (!geometry) {
					//callback({type: 'loading_failed'});
					console.error(new Error(`failed to load point cloud from URL: ${path}`));
				} else {
					let pointcloud = new PointCloudOctree(geometry);
					// loaded(pointcloud);
					resolve({type: 'pointcloud_loaded', pointcloud: pointcloud});
				}
			});
		} else if (path.indexOf('metadata.json') > 0) {
			// AUDIT-2026-09-19.md finding #3: a second, dead OctreeLoader.load()
			// call used to sit here, passing a callback as a 2nd argument that
			// OctreeLoader.load(url) (single-parameter signature) simply
			// ignores - so that callback, including its own resolve(...), NEVER
			// ran. But the call itself still executed in full: a second
			// metadata.json fetch, a second OctreeGeometry/root node, and a
			// second real load of the root node's point data (octree.bin/
			// hierarchy.bin + a decode worker), all silently discarded once
			// done. Confirmed identical in upstream potree/potree (inherited,
			// not fork-introduced) - upstream issues #1440 and #865 report the
			// exact same bug, unresolved since 2020, no maintainer explanation
			// or fix. Removed as pure dead weight: every point cloud open paid
			// for a second, fully real network+decode cycle whose result
			// nothing could ever use.
			Potree.OctreeLoader.load(path).then(e => {
				let geometry = e.geometry;

				if(!geometry){
					console.error(new Error(`failed to load point cloud from URL: ${path}`));
				}else{
					let pointcloud = new PointCloudOctree(geometry);

					let aPosition = pointcloud.getAttribute("position");

					let material = pointcloud.material;
					material.elevationRange = [
						aPosition.range[0][2],
						aPosition.range[1][2],
					];

					// loaded(pointcloud);
					resolve({type: 'pointcloud_loaded', pointcloud: pointcloud});
				}
			});
		} else if (path.indexOf('.vpc') > 0) {
			PointCloudArena4DGeometry.load(path, function (geometry) {
				if (!geometry) {
					//callback({type: 'loading_failed'});
					console.error(new Error(`failed to load point cloud from URL: ${path}`));
				} else {
					let pointcloud = new PointCloudArena4D(geometry);
					// loaded(pointcloud);
					resolve({type: 'pointcloud_loaded', pointcloud: pointcloud});
				}
			});
		} else {
			//callback({'type': 'loading_failed'});
			console.error(new Error(`failed to load point cloud from URL: ${path}`));
		}
	});

	if(callback){
		promise.then(pointcloud => {
			loaded(pointcloud);
		});
	}else{
		return promise;
	}
};


// add selectgroup
(function($){
	$.fn.extend({
		selectgroup: function(args = {}){

			let elGroup = $(this);
			let rootID = elGroup.prop("id");
			let groupID = `${rootID}`;
			let groupTitle = (args.title !== undefined) ? args.title : "";

			let elButtons = [];
			elGroup.find("option").each((index, value) => {
				let buttonID = $(value).prop("id");
				let label = $(value).html();
				let optionValue = $(value).prop("value");

				let elButton = $(`
					<span style="flex-grow: 1; display: inherit">
					<label for="${buttonID}" class="ui-button" style="width: 100%; padding: .4em .1em">${label}</label>
					<input type="radio" name="${groupID}" id="${buttonID}" value="${optionValue}" style="display: none"/>
					</span>
				`);
				let elLabel = elButton.find("label");
				let elInput = elButton.find("input");

				elInput.change( () => {
					elGroup.find("label").removeClass("ui-state-active");
					elGroup.find("label").addClass("ui-state-default");
					if(elInput.is(":checked")){
						elLabel.addClass("ui-state-active");
					}else{
						//elLabel.addClass("ui-state-default");
					}
				});

				elButtons.push(elButton);
			});

			let elFieldset = $(`
				<fieldset style="border: none; margin: 0px; padding: 0px">
					<legend>${groupTitle}</legend>
					<span style="display: flex">

					</span>
				</fieldset>
			`);

			let elButtonContainer = elFieldset.find("span");
			for(let elButton of elButtons){
				elButtonContainer.append(elButton);
			}

			elButtonContainer.find("label").each( (index, value) => {
				$(value).css("margin", "0px");
				$(value).css("border-radius", "0px");
				$(value).css("border", "1px solid black");
				$(value).css("border-left", "none");
			});
			elButtonContainer.find("label:first").each( (index, value) => {
				$(value).css("border-radius", "4px 0px 0px 4px");

			});
			elButtonContainer.find("label:last").each( (index, value) => {
				$(value).css("border-radius", "0px 4px 4px 0px");
				$(value).css("border-left", "none");
			});

			elGroup.empty();
			elGroup.append(elFieldset);



		}
	});
})(jQuery);
